"use strict";
import { HoverableValueMixin } from "../hoverable_value_mixin";
export default React.createClass({
  mixins: [HoverableValueMixin],
  getInitialState: function() {
    return {};
  },
  render: function() {
    return /* @__PURE__ */ React.createElement("div", null, this.showValue(this.props.value));
  },
  showValue: function(value) {
    return this.showHoverableValue(value);
  }
});
